import { Component, OnInit } from '@angular/core';
import {ServiceAccessComponent} from '../../service-access/service-access.component';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {AlertaService} from '../../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-nrs-service-access',
  templateUrl: './nrs-service-access.component.html',
  styleUrls: ['./nrs-service-access.component.scss']
})
export class NrsServiceAccessComponent extends ServiceAccessComponent implements OnInit {

    constructor(protected portalServiceFactory: PortalServiceFactoryService, protected alertaHandler:AlertaService) {
        super(portalServiceFactory, alertaHandler);
    }

    ngOnInit() {
        super.ngOnInit();
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/nrs/nrs-service-access/nrs-service-access.component.ts